import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-unauthenticated',
    templateUrl: './unauthenticated.component.html',
    styleUrls: ['./unauthenticated.component.scss'],
    imports: [RouterOutlet]
})
export class UnauthenticatedComponent {

}
